import {Component, Input} from '@angular/core';

@Component({
  selector: 'pt-sidebar-item-footer',
  template: `
    <div class='sidebar-footer' [ngClass]='{ "sidebar-footer--collapsed": collapsed}'>

      <div class="version" *ngIf="version && !collapsed">
        v.{{ version }}
      </div>

      <a href='https://www.valuedatatrust.com/' target='_blank' *ngIf='!collapsed'>
        <span class='text-muted'>Powered by</span>
        <img src='./assets/images/value-data-trust-favicon.png' width='18px' alt="">
        <span style='font-family: monospace; color: var(--ptColor)'>ValueDataTrust</span>
      </a>

      <a href='https://www.valuedatatrust.com/' target='_blank' *ngIf='collapsed'>
        <img src='./assets/images/value-data-trust-favicon.png' width='20px' alt="">
      </a>

    </div>
  `,
  styles: [`
    .sidebar-footer {
      width: 100%;
      display: flex;
      padding: 6px 0;
      cursor: pointer;
      position: relative;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }

    .sidebar-footer .version {
      display: flex;
      margin: 8px 0 0 0;
      opacity: .7;
    }
    .sidebar-footer img {
      margin: 0 4px 0 4px;
    }

    .sidebar-footer--collapsed {
      display: flex;
      cursor: pointer;
      justify-content: center;
    }

  `]
})
export class SidebarItemFooterComponent {
  @Input() collapsed: boolean;
  @Input() version?: string;
}
